module.exports = {
	siteMetadata: {
		title: "Bawa Masala Company",
		url: "https://bawamasalacompany.com",
		description: "BMC has a legacy of over seven decades in bringing premium quality Indian spices and masala blends to kitchens and dealers across India.",
		image: "https://bawamasalacompany.com/assets/images/Elements/BG2.png"
	},
	plugins: [
		{
			resolve: "gatsby-plugin-google-analytics",
			options: {
				trackingId: "UA-128160439-1",
			},
		},
		// {
		// 	resolve: `gatsby-plugin-facebook-pixel`,
		// 	options: {
		// 		pixelId: "145006083100066",
		// 	},
		// }
	],
}



// WEBPACK FOOTER //
// ./gatsby-config.js